
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { LucideIcon } from 'lucide-react';

// Payment method type
export interface PaymentMethodType {
  id: string;
  name: string;
  icon: LucideIcon;
}

interface PaymentMethodProps {
  paymentMethods: PaymentMethodType[];
  selectedPayment: string;
  setPaymentMethod: (id: string) => void;
}

const PaymentMethod: React.FC<PaymentMethodProps> = ({
  paymentMethods,
  selectedPayment,
  setPaymentMethod,
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <h2 className="text-xl font-semibold mb-4">Payment Method</h2>
      <div className="space-y-3">
        {paymentMethods.map((method) => (
          <div 
            key={method.id}
            className={`flex items-center p-3 border rounded-md cursor-pointer ${
              selectedPayment === method.id ? 'border-ahavex-blue bg-blue-50' : 'border-gray-200'
            }`}
            onClick={() => setPaymentMethod(method.id)}
          >
            <div className={`w-5 h-5 rounded-full border flex items-center justify-center mr-3 ${
              selectedPayment === method.id ? 'border-ahavex-blue' : 'border-gray-300'
            }`}>
              {selectedPayment === method.id && (
                <div className="w-3 h-3 rounded-full bg-ahavex-blue" />
              )}
            </div>
            <method.icon className="w-5 h-5 mr-2 text-gray-600" />
            <span>{method.name}</span>
          </div>
        ))}
      </div>
      {selectedPayment === 'card' && (
        <div className="mt-4 p-4 border border-gray-200 rounded-md space-y-4">
          <div>
            <Label htmlFor="cardNumber">Card Number</Label>
            <Input id="cardNumber" placeholder="0000 0000 0000 0000" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label htmlFor="expiry">Expiry Date</Label>
              <Input id="expiry" placeholder="MM / YY" />
            </div>
            <div>
              <Label htmlFor="cvv">CVV</Label>
              <Input id="cvv" placeholder="123" />
            </div>
          </div>
        </div>
      )}
      {selectedPayment === 'momo' && (
        <div className="mt-4 p-4 border border-gray-200 rounded-md">
          <Label htmlFor="momoNumber">Mobile Money Number</Label>
          <Input id="momoNumber" placeholder="07X XXX XXXX" />
        </div>
      )}
      {selectedPayment === 'flutterwave' && (
        <div className="mt-4 p-4 border border-gray-200 rounded-md">
          <p className="text-sm text-gray-600 mb-2">You will be redirected to Flutterwave's secure payment page to complete your transaction after clicking "Place Order".</p>
        </div>
      )}
    </div>
  );
};

export default PaymentMethod;
